import type { NotificationEntity } from '../domain/entities/NotificationEntity.js';

export interface TypeMeta { label: string; color: string }

/** Visual metadata per notification type. */
export const TYPE_META: Record<string, TypeMeta> = {
  assignment: { label: 'Phân công', color: 'var(--accent)' },
  checkin: { label: 'Check-in', color: 'var(--green)' },
  checkout: { label: 'Check-out', color: 'var(--amber)' },
  activity: { label: 'Hoạt động', color: 'var(--text2)' },
  reminder: { label: 'Nhắc nhở', color: 'var(--red)' },
  payout: { label: 'Biên bản', color: 'var(--blue)' },
  inactivity_alert: { label: 'Không hoạt động', color: 'var(--orange)' },
};

export function typeMeta(type: string): TypeMeta {
  return TYPE_META[type] ?? { label: type, color: 'var(--text2)' };
}

/** Map a notification's resource/resource_id to an in-app route. */
export function routeForNotification(n: Pick<NotificationEntity, 'resource' | 'resourceId' | 'metadata'>): string {
  switch (n.resource) {
    case 'issue':
      return `/issues?drawer=${n.resourceId}`;
    case 'session':
      return '/sessions';
    case 'sessions_of_project':
      return `/projects/${n.resourceId}/sessions`;
    case 'project':
      return `/projects/${n.resourceId}`;
    case 'payout':
      return n.metadata?.['status'] === 'validated'
        ? `/accountant/payouts/${n.resourceId}`
        : `/payout/${n.resourceId}`;
    default:
      return '/notifications';
  }
}

